import React from 'react';
import cx from 'classnames';
import s from './s.module.less';

type Props = {
    // 由 Form.Item 注入
    value?: 'yes' | 'no';
    onChange?: (v: 'yes' | 'no') => void;
    yesLabel: string;
    noLabel: string;
};

// 两键 toggle（原型 .ibbw-toggle）：yes / no 两个宽按钮，选中态蓝框浅蓝底
export default function YesNoToggle({ value, onChange, yesLabel, noLabel }: Props) {
    return (
        <div className={s.toggleGroup}>
            <button
                type="button"
                className={cx(s.toggleBtn, value === 'yes' && s.selected)}
                onClick={() => onChange?.('yes')}
            >
                {yesLabel}
            </button>
            <button
                type="button"
                className={cx(s.toggleBtn, value === 'no' && s.selected)}
                onClick={() => onChange?.('no')}
            >
                {noLabel}
            </button>
        </div>
    );
}
